<template>
	<div>
		<PostalCodeEdit
			v-model="postalCode"
			:meta="meta"
			@input="emitChangeEvent"
		/>
		<b-row class="mt-2">
			<b-col md="5">
				<FormGroup
					label="Straße"
					:state="streetValid"
					invalid-feedback="Bitte gib die Straße ein"
					feedback-beneath
				>
					<b-input v-model="street" @input="emitChangeEvent"/>
				</FormGroup>
			</b-col>
			<b-col md="2">
				<FormGroup
					label="Hausnummer"
					:state="streetNumberValid"
					invalid-feedback="Bitte gib die Hausnummer ein"
					feedback-beneath
				>
					<b-input v-model="streetNumber" @input="emitChangeEvent"/>
				</FormGroup>
			</b-col>
			<b-col md="5">
				<FormGroup label="Nähere Angaben zum Ort" description="z.B. Name des Restaurants, ...">
					<b-input v-model="extraInfo" @input="emitChangeEvent"/>
				</FormGroup>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import {isDefined} from "@/helper/Value";
import {isEmptyOrNull, stringOrNull} from "@/helper/String";
import FormGroup from "@/vue/common/form/Group";
import PostalCodeEdit from "@/vue/common/postal-code/Edit";
import {mapState} from "vuex";

export default {

	components: {
		PostalCodeEdit,
		FormGroup,
	},

	data ()
	{
		return {
			street: '',
			streetNumber: '',
			postalCode: undefined,
			extraInfo: '',
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		streetValid ()
		{
			return !isEmptyOrNull(this.street);
		},
		streetNumberValid ()
		{
			return !isEmptyOrNull(this.streetNumber);
		},
		dataValid ()
		{
			return this.streetValid
				&& this.streetNumberValid
				&& isDefined(this.postalCode);
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				street: this.street,
				streetNumber: this.streetNumber,
				postalCode: this.postalCode,
				extraInfo: stringOrNull(this.extraInfo)
			});
		}
	}
}
</script>
